import Spinner from './Swrapper.vue';
export default Spinner;



// WEBPACK FOOTER //
// ./src/pages/profile/components/wrapper/swrapper/index.ts